<template>
  <div class="device-usage-charts">
    <ReportingCard title="Device Usage" class="h-100">
      <RChartDonut :data="data.devices" :options="options" />
    </ReportingCard>
    <ReportingCard title="Browser Usage" class="h-100">
      <RChartDonut :data="data.browsers" :options="options" />
    </ReportingCard>
    <ReportingCard title="Operating System" class="h-100">
      <RChartDonut :data="data.operating_systems" :options="options" />
    </ReportingCard>
  </div>
</template>

<script>
import { RChartDonut } from '@/components/charts'
import { ReportingCard } from '@/views/reporting/_components'

export default {
  name: 'DeviceUsageCharts',
  components: {
    ReportingCard,
    RChartDonut
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      options: {
        chart: {
          height: 100
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.device-usage-charts {
  display: flex;
  flex-direction: column;
  height: 100%;
}

::v-deep .c-card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

::v-deep .c-card-body {
  padding: 0.75rem;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
